<template>
  <div>
    <h3>{{ text['0004'] }} 4/4</h3>
    <hr class="title">
    <h2>{{ text['0017'] }}</h2>
    <p class="subtitle">
      {{ text['0018'] }}
      <br>
      {{ text['0019'] }}
    </p>

    <div style="text-align: center;">
      <a
        :href="`https://www.futech-tools.com/en/compare/?ids=[${result[0].prid}][${result[1].prid}][${result[2].prid}]`"
        target="_blank"
        class="compare"
      >{{ text['0044'] }}</a>
    </div>

    <div
      v-for="(laser,sqce) in result"
      v-if="(Math.round((laser.score / maxScore ) * 100) > 60)"
      class="result"
    >
      <div class="result-title">
        <h1>
          {{ (sqce + 1) }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            style="color: black;text-decoration: none;"
            :href="`https://www.futech-tools.com/en/p/${laser.prid}`"
            target="_blank"
          >{{ laser.text }}</a>
        </h1>
        <h2>{{ Math.round((laser.score / maxScore ) * 100) }}% {{ text['0020'] }}</h2>
      </div>
      <div class="result-body">
        <div class="result-image">
          <a :href="`https://www.futech-tools.com/en/p/${laser.prid}`" target="_blank">
            <img
              class="result-image"
              :src="`https://www.futech-tools.com/assets/img/imgprd/${laser.img}`"
            >
          </a>
          <div class="price-cat">{{ "€".repeat(laser.pricecat) }}</div>
        </div>
        <div>
          {{ laser.descr }}
          <div class="room-list" v-if="laser.room">
            <img
              v-for="room in laser.room.split(',')"
              :src="`https://www.futech-tools.com/assets/img/imgrm/${room}`"
            >
            <a
              :href="`https://www.futech-tools.com/en/dealers`"
              target="_blank"
              class="buy-now"
            >{{ text['0041'] }}</a>
            <br>
            <a
              style="margin-top: 25px;margin-right:-73px;"
              :href="`https://www.futech-tools.com/en/p/${laser.prid}`"
              target="_blank"
              class="buy-now"
            >{{ text['0043'] }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      text: "getText",
      result: "getResult",
      maxScore: "getMaxScore",
      currentLanguage: "getLanguage"
    }),
    filteredCategories() {
      const categoryArray = this.applications;
      let resultObject = {};
      for (const ackey in categoryArray) {
        if (categoryArray[ackey].selected) {
          resultObject[ackey] = categoryArray[ackey];
        }
      }
      return resultObject;
    }
  },
  methods: {
    ...mapActions({
      toggleApplicationSelection: "application/toggleApplicationSelection"
    }),
    isSelected(categoryId, applicationId) {
      return this.applications[categoryId].apps[applicationId].selected;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/screens/Result.vue